import { memo } from 'react'

interface MemberInfoProps {
  name: string
  role: string
  className?: string
}

const MemberInfo: React.FC<MemberInfoProps> = memo(
  ({ name, role, className = '' }) => {
    return (
      <div
        className={`group-hover:opacity-100 tc-mv-onboarding-member-info flex flex-col justify-center items-center whitespace-nowrap text-center transition-opacity duration-300 ${className}`}
      >
        <div className="text-[28px] leading-7 font-seriftext">{role}</div>
        <div className="text-lg opacity-70">{name}</div>
      </div>
    )
  },
)

export { MemberInfo }
